import React from 'react';
import { Navigate, Outlet, useOutletContext, useParams } from 'react-router-dom';

import { TrackingRoute } from 'commons/eventing';
import NotFound from 'dashboard/pages/NotFound';

import SegmentExisting from './SegmentExisting';
import Analytics, { ANALYTICS_ROUTE } from './pages/Analytics';
import {
  Review,
  Information,
  Conditions,
  CONDITIONS_ROUTE,
  INFORMATION_ROUTE,
  REVIEW_ROUTE,
} from './pages/Create';
import Definition, { DEFINITION_ROUTE } from './pages/Definition';
import MembershipDebugger, { MEMBERSHIP_DEBUGGER_ROUTE } from './pages/MembershipDebugger';
import Settings, { SETTINGS_ROUTE } from './pages/Settings';

const SegmentWithId = () => {
  const params = useParams();
  return <SegmentExisting segmentId={params.id} />;
};

type WithContextProps = {
  children: ({ segmentId }: { segmentId: string }) => JSX.Element;
  pageName: string;
};

const WithContext = ({ children, ...props }: WithContextProps) => {
  const { segmentId } = useOutletContext<{ segmentId: string }>();
  return (
    <TrackingRoute {...props} properties={{ segmentId }}>
      {children({ segmentId })}
    </TrackingRoute>
  );
};

export const segmentRoutes = [
  {
    path: 'new/*',
    element: (
      <TrackingRoute pageName="segments.create">
        <Outlet />
      </TrackingRoute>
    ),
    children: [
      { path: '', element: <Navigate to={`./${INFORMATION_ROUTE.path}`} replace /> },
      { path: INFORMATION_ROUTE.path, element: <Information /> },
      { path: CONDITIONS_ROUTE.path, element: <Conditions /> },
      { path: REVIEW_ROUTE.path, element: <Review /> },
      { path: '*', element: <NotFound /> },
    ],
  },
  {
    path: ':id/*',
    element: (
      <TrackingRoute>
        <SegmentWithId />
      </TrackingRoute>
    ),
    children: [
      {
        path: DEFINITION_ROUTE.path,
        element: (
          <WithContext pageName="segments.definition">
            {({ segmentId }) => <Definition segmentId={segmentId} />}
          </WithContext>
        ),
      },
      {
        path: ANALYTICS_ROUTE.path,
        element: (
          <WithContext pageName="segments.analytics">
            {({ segmentId }) => <Analytics segmentId={segmentId} />}
          </WithContext>
        ),
      },
      {
        path: SETTINGS_ROUTE.path,
        element: (
          <WithContext pageName="segments.settings">
            {({ segmentId }) => <Settings segmentId={segmentId} />}
          </WithContext>
        ),
      },

      {
        path: MEMBERSHIP_DEBUGGER_ROUTE.path,
        element: (
          <WithContext pageName="segments.membershipDebugger">
            {({ segmentId }) => <MembershipDebugger segmentId={segmentId} />}
          </WithContext>
        ),
      },
    ],
  },
];
